import React, { useState } from 'react';
import { AuthWizardContext } from '../../../context/Context';

// initialUser: valores con que arrancan los campos del asistente (p. ej. la cédula buscada)
const AuthWizardProvider = ({ children, initialUser }) => {
  const [user, setUser] = useState(initialUser || {});
  const [step, setStep] = useState(1);

  const handleInputChange = ({ value, name }) => setUser({ ...user, [name]: value });

  const value = { user, setUser, step, setStep, handleInputChange };
  return <AuthWizardContext.Provider value={value}>{children}</AuthWizardContext.Provider>;
};

export default AuthWizardProvider;
